import React, { useState } from "react";
import "./ApikeyDialog.scss";
import ReactLoading from "react-loading";
import { notify } from "../../utils/services/notification";
import { createAPIKey } from "../../utils/services/lighthouse";

interface ApikeyDialogProps {
  keyName: string;
  setKeyDialog: (value: boolean) => void;
}

const ApikeyDialog: React.FC<ApikeyDialogProps> = ({
  keyName,
  setKeyDialog,
}) => {
  const [screen, setScreen] = useState<string>("confirm");
  const [apiKey, setApiKey] = useState<string | null>(null);

  const createKey = async () => {
    try {
      setScreen("loading");
      const response = await createAPIKey(keyName);
      setApiKey(response);
      setScreen("details");
    } catch (err) {
      setKeyDialog(false);
    }
  };

  const copyToClipboard = () => {
    if (apiKey) {
      navigator.clipboard.writeText(apiKey);
      notify("Copied To Clipboard", "success");
    }
  };

  const downloadFile = () => {
    try {
      if (apiKey) {
        const element = document.createElement("a");
        const file = new Blob([apiKey], {
          type: "text/plain",
        });
        element.href = URL.createObjectURL(file);
        element.download = `${"Apikey"}.txt`;
        document.body.appendChild(element);
        element.click();
      }
    } catch (err) {
      //
    }
  };

  const renderScreen = () => {
    switch (screen) {
      case "loading":
        return (
          <div className="loadingContainer">
            <ReactLoading
              type={"bubbles"}
              color={"#4452FE"}
              height={667}
              width={375}
            />
          </div>
        );
      case "confirm":
        return (
          <div className="ConfirmSection">
            <p className="ConfirmSection__title">
              Are you sure you want to generate API Key?
            </p>
            <div className="ConfirmSection__imageContainer">
              <img src="/icons/Apikey_Icon.png" alt="apikeyIcon" />
            </div>

            <p className="ConfirmSection__note">
              Note: You need to save this key as we won’t store it.
            </p>

            <div className="ConfirmSection__ButtonContainer">
              <button
                onClick={() => {
                  setKeyDialog(false);
                }}
              >
                No
              </button>
              <button onClick={createKey}>Yes</button>
            </div>
          </div>
        );
      case "details":
        return (
          <div className="DetailSection">
            <p className="DetailSection__title">
              Key has been generated successfully
            </p>

            <div className="DetailSection__key">
              <input
                type="text"
                className="outlineInput"
                value={apiKey || ""}
                disabled={true}
              />
            </div>

            <p className="DetailSection__note">
              <b>Please Note:</b> Once the key is generated, it can&#39;t be
              retrieved later. <br /> Either Download the Key File or write it
              down at a secure location
            </p>

            <div className="DetailSection__ButtonContainer">
              <button onClick={copyToClipboard}>Copy To Clipboard</button>
              <button onClick={downloadFile}>Download Key</button>
            </div>
          </div>
        );
      default:
        return <></>;
    }
  };

  return <div className="ApikeyDialog">{renderScreen()}</div>;
};

export default ApikeyDialog;
